import { useEffect } from 'react';
import { useState, useRef, useCallback } from 'react';

export function usePaginate() {
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const fetchIdRef = useRef(0);
  const handleOnTableChange = useCallback(
    (reportsData, { pageSize, pageIndex }) => {
      const fetchId = ++fetchIdRef.current;
      if (fetchId === fetchIdRef.current) {
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        const pageData = reportsData.slice(startRow, endRow);
        setData(pageData);
        setPageCount(Math.ceil(reportsData.length / pageSize));
      }
    },
    []
  );
  return {
    data,
    pageCount,
    handleOnTableChange,
  };
}
